import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { BuilderCommunicationService } from '@website-builder/application/builder-communication.service';
import { MaterialIconsService } from '@website-builder/application/material-icons.service';
import { appRoutes } from '@app/app.routes';
import { IconRepositoryService } from '@app/icon-repository.service';
import { SHARED_ASSETS_PATH } from '@tess-core/shared';
import { ThemeService } from '@core/services/theme.service';
import { API_BASE_URL, TESS_API_URL } from '@core/http/api.config';
import { environment } from '@environments/environment';
import { MatNativeDateModule } from '@angular/material/core';
import { AuthService } from '@core/services/auth.service';
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';

function initIcons(matIconService: MaterialIconsService): () => void {
  return () => matIconService.addInitialIcons();
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(MatNativeDateModule),
    BuilderCommunicationService,
    IconRepositoryService,
    {
      provide: SHARED_ASSETS_PATH,
      useValue: './shared/assets',
    },
    {
      provide: API_BASE_URL,
      useValue: environment.apiUrl,
    },
    {
      provide: TESS_API_URL,
      useValue: environment.tessApiUrl,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      inject(ThemeService);
      const initializerFn = initIcons(inject(MaterialIconsService));
      return initializerFn();
    }),
    provideAppInitializer(() => inject(AuthService).initializeTemporaryAuthentication()),

    provideEnvironmentInitializer(() => {
      inject(IconRepositoryService);
    }),
  ],
};
